import { type Tables } from '@aikoa/common'
import { z } from 'zod/v4'

const INVOICE_VALIDATION_MESSAGES = {
  organisation_name: 'Yrityksen nimi on pakollinen',
  organisation_identifier: 'Y-tunnus on pakollinen',
  e_invoice_address: 'Verkkolaskuosoite on pakollinen',
  e_invoice_operator: 'Verkkolaskuoperaattori on pakollinen',
  reference: 'Viite on pakollinen',
  terms_agreement: 'Laskutusehtojen hyväksyminen on pakollista',
}

export const invoiceSchema = z.object({
  organisation_name: z.string().min(1, { message: INVOICE_VALIDATION_MESSAGES.organisation_name }),
  organisation_identifier: z
    .string()
    .min(1, { message: INVOICE_VALIDATION_MESSAGES.organisation_identifier }),
  e_invoice_address: z.string().min(1, { message: INVOICE_VALIDATION_MESSAGES.e_invoice_address }),
  e_invoice_operator: z
    .string()
    .min(1, { message: INVOICE_VALIDATION_MESSAGES.e_invoice_operator }),
  reference: z.string().min(1, { message: INVOICE_VALIDATION_MESSAGES.reference }),
  terms_agreement: z.boolean().refine((data) => data, {
    message: INVOICE_VALIDATION_MESSAGES.terms_agreement,
  }),
})

export type PaymentMethod = 'invoice'
export type InvoiceDetails = Tables<'invoicing_details'>
